import React, { useEffect, useState } from "react";
import {
    Animated, Dimensions,
    SectionList,
    SectionListProps,
    StyleProp, Text,
    View,
    ViewStyle,
} from "react-native";
import sectionListGetItemLayout from "react-native-section-list-get-item-layout";
import { AlphabetList } from "./AlphabetList";

interface LexicalSectionListProps extends SectionListProps<any> {
    style?: StyleProp<ViewStyle>;
    listStyle?: StyleProp<ViewStyle>;
    itemHeight: number;
    sectionHeaderHeight?: number;
    sectionFooterHeight?: number;
    separatorHeight?: number;
    listHeaderHeight?: number;
    disableScrollToTopOnDataUpdate?: boolean;
    stickyHeader?:boolean;
    alphabetListOptions: { itemHeight: number; [key: string]: any };
}

const LexicalSectionList = (props: LexicalSectionListProps) => {
    const [sectionListRef, setSectionListRef] = useState<SectionList | null>();

    useEffect(() => {
        if (
            !props.disableScrollToTopOnDataUpdate &&
            props.sections &&
            sectionListRef &&
            props.sections.length
        ) {
       /*     sectionListRef.scrollToLocation({
                sectionIndex: 0,
                itemIndex: 0,
            });*/
        }
    }, [props.sections]);
    const getItemLayoutParams = { getItemHeight: () => props.itemHeight };
    Object.assign(
        getItemLayoutParams,
        props.separatorHeight !== undefined && {
            getSeparatorHeight: () => props.separatorHeight,
        },
        props.sectionHeaderHeight !== undefined && {
            getSectionHeaderHeight: () => props.sectionHeaderHeight,
        },
        props.sectionFooterHeight !== undefined && {
            getSectionFooterHeight: () => props.sectionFooterHeight,
        },
        props.listHeaderHeight && { listHeaderHeight: props.listHeaderHeight }
    );
    const getItemLayout = sectionListGetItemLayout(getItemLayoutParams);

    // avoid at render...
    const { width, height } = Dimensions.get('window');

    return (
        <View style={props.style}>

            <Animated.SectionList
                style={[props.listStyle,{width:width,flex:1}]}
                ref={(ref) => {
                    setSectionListRef(ref);
                }}
                getItemLayout={(data, index) =>
                    getItemLayout(data as { title: string; data: any[] }[], index)
                }
                stickySectionHeadersEnabled={props.stickyHeader}
                maxToRenderPerBatch={100}
                initialNumToRender={100}
                {...props}
            />
{/*            <View
                style={{
                    position: "absolute",
                    alignSelf: "flex-end",
                    right: 8,
                    height: "100%",
                    justifyContent: "center",
                }}
            >
                <AlphabetList
                    data={props.sections.map((section) => section.title)}
                    onItemSelect={(item, index) => {
                        if (sectionListRef) {
                            sectionListRef.scrollToLocation({
                                sectionIndex: index,
                                itemIndex: 0,
                            });
                        }
                    }}
                    {...props.alphabetListOptions}
                />
            </View>*/}
        </View>
    );
};

export default LexicalSectionList;
